import FJAppConstant from '../../constants/FJAppConstant';
// import { RELEASE } from '../../constants/FJEvnConstant';
// const environment = import.meta.env.MODE;
// const isRelease = environment === RELEASE;
// const staticResourceServe = isRelease ? 'https://resource.flexclip.com/' : `/`;
const staticResourceServe = 'https://resource.flexclip.com/';

export default {
    appType: FJAppConstant.AI_COMMUNITY,
    templateImagePath: `${staticResourceServe}templates/cover/w400/`,
    templateVideoPath: `${staticResourceServe}templates/video/226p/`,
    templateVideoPathHeight: `${staticResourceServe}templates/video/720p/`,
    viceTemplateImagePath: `${staticResourceServe}templates/cover/`,
    viceTemplateVideoPath: `${staticResourceServe}templates/video/`,
    viceTemplateBoardImagePath: `${staticResourceServe}templates/board-cover/`,
};
